export type ItemPagina = number | 'reticencias-inicio' | 'reticencias-fim';

/**
 * Números de página a mostrar: sempre a primeira e a última, a atual com uma vizinha de cada lado
 * e reticências onde houver salto ("1 … 4 5 6 … 20"). Até 7 páginas, mostra todas.
 */
export function paginasVisiveis(atual: number, totalPaginas: number): ItemPagina[] {
  if (totalPaginas <= 7) return Array.from({ length: totalPaginas }, (_, i) => i + 1);
  const inicio = Math.max(2, Math.min(atual - 1, totalPaginas - 4));
  const fim = Math.min(totalPaginas - 1, Math.max(atual + 1, 5));
  const meio = Array.from({ length: fim - inicio + 1 }, (_, i) => inicio + i);
  return [
    1,
    ...(inicio > 2 ? (['reticencias-inicio'] as const) : []),
    ...meio,
    ...(fim < totalPaginas - 1 ? (['reticencias-fim'] as const) : []),
    totalPaginas,
  ];
}

/** "26–50 de 231" (vazio: "Nenhum resultado"). */
export function faixaDaPagina(pagina: number, porPagina: number, total: number): string {
  if (total === 0) return 'Nenhum resultado';
  const de = (pagina - 1) * porPagina + 1;
  const ate = Math.min(pagina * porPagina, total);
  const n = (v: number) => v.toLocaleString('pt-BR');
  return `${n(de)}–${n(ate)} de ${n(total)}`;
}
